import React  from 'react';
import countries from './countries';
import get_bundle from './get_bundle';
import SharePurchase from '../components/SharePurchase';
import { template } from '../../template';

const Share_Purchase = {
  current: null,
  create: function(share_purchase_url, locale, purchase, do_share) {
    var formatted_currency = locale.locale_bundle().currency[purchase.currency];
    var format_currency = function(n) {
      return formatted_currency + ' ' + locale.format_number(n, 2);
    };
    var bonus = format_currency(countries.data[locale.country].bonus);
    var discount = format_currency(purchase.discount);
    var bundle = get_bundle(locale).share_purchase;
    var _share_purchase_url = share_purchase_url + '?productId=' + purchase.productId
    Share_Purchase.current = {
      bonus: bonus,
      html: function() {
        return <SharePurchase share_purchase_url={_share_purchase_url} bundle={bundle} />;
      },
      data: function() {
        return {
          locale: String(locale),
          language: locale.language,
          target: 'http://madai.com',
          name: purchase.product,
          caption: 'madai',
          picture: purchase.image,
          description: template(bundle.description)({
            product: purchase.product,
            discount: discount
          })
        };
      },
      do_share: do_share
    };
  }
};

export default Share_Purchase;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/SharePurchase.js
 **/